import Request from '@/utils/request'

// 复购活动
export function repurchaseActCfg () {
  return Request({
    url: `/api/v2/app/shop/activity/8/cfg`,
    method: "get"
  });
}

// 复购活动领取
export function repurchaseActClaim (rewardId) {
  return Request({
    url: `/api/v2/app/shop/activity/8/reward/${rewardId}`,
    method: "put"
  });
}